interface LUMPSUM_CALCULATOR_FORMULA_PROPS {
  investmentAmount: number | undefined;
  durationOfSip: number | undefined;
  annualrate: number | undefined;
}

export const LUMPSUM_CALCULATOR_FORMULA = ({
  investmentAmount,
  durationOfSip,
  annualrate,
}: LUMPSUM_CALCULATOR_FORMULA_PROPS) => {
  if (
    !investmentAmount ||
    !durationOfSip ||
    !annualrate ||
    investmentAmount < 0 ||
    durationOfSip < 0 ||
    annualrate < 0
  ) {
    return {
      totalWealth: 0,
      wealthGained: 0,
    };
  }

  const presentInvestmentValue = Math.round(
    Number(investmentAmount * Math.pow(1 + annualrate / 100, durationOfSip))
  );

  const interestEarned = presentInvestmentValue - investmentAmount;

  return { totalWealth: presentInvestmentValue, wealthGained: interestEarned };
};
